import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, KeyRound, Layers } from "lucide-react";
import { CHAINS } from "@/lib/chains";
import ChainIcon from "@/components/ChainIcon";

export default function Onboarding() {
  const nav = useNavigate();
  return (
    <div className="cw-shell min-h-screen justify-between px-6 py-10">
      <div className="fade-up">
        <div className="mb-3 flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl border border-neon/40 bg-neon/5">
            <Layers className="h-5 w-5 text-neon" />
          </div>
          <span className="font-outfit text-lg font-bold tracking-tight">CoreWallet</span>
        </div>

        <h1 className="mt-10 font-outfit text-4xl font-extrabold leading-tight sm:text-5xl">
          Your keys.<br />
          <span className="text-neon">Six chains.</span><br />
          One vault.
        </h1>
        <p className="mt-5 max-w-sm font-sans text-sm leading-relaxed text-[#9CA3AF]">
          A non-custodial HD wallet for Bitcoin, Ethereum, BNB Chain, Polygon,
          Solana &amp; Tron. Keys are generated and encrypted on your device — never
          on a server.
        </p>

        <div className="mt-9 flex items-center gap-3">
          {CHAINS.map((c) => (
            <ChainIcon key={c.id} chain={c} size={38} />
          ))}
        </div>

        <div className="mt-10 space-y-3">
          <Feature icon={ShieldCheck} title="Self-custodial" desc="AES-256 encrypted, PIN locked, on-device only." />
          <Feature icon={KeyRound} title="BIP-39 / BIP-44" desc="Standard seed phrase, portable to any wallet." />
        </div>
      </div>

      <div className="mt-10 space-y-3">
        <button
          data-testid="create-wallet-button"
          onClick={() => nav("/create")}
          className="w-full rounded-2xl bg-neon py-4 font-outfit text-base font-bold text-[#08090C] transition-transform active:scale-[0.98] neon-glow"
        >
          Create a new wallet
        </button>
        <button
          data-testid="import-wallet-button"
          onClick={() => nav("/import")}
          className="w-full rounded-2xl border border-[#1F2430] bg-[#12141A] py-4 font-outfit text-base font-semibold text-white transition-colors hover:border-neon/40"
        >
          I already have a wallet
        </button>
      </div>
    </div>
  );
}

function Feature({ icon: Icon, title, desc }) {
  return (
    <div className="flex items-start gap-3 card-surface p-4">
      <Icon className="mt-0.5 h-5 w-5 shrink-0 text-neon" />
      <div>
        <p className="font-outfit text-sm font-semibold text-white">{title}</p>
        <p className="font-sans text-xs text-[#9CA3AF]">{desc}</p>
      </div>
    </div>
  );
}
